import React from 'react'
import CardClass from '../CardClass/CardClass';
import { Grid, Skeleton, TablePagination, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateRowsPerPage, updateSkip } from '../../../../../store/actions/datatable.actions';

const ViewGrid = ({ list, totalList, skip, rowsPerPage, columns, loading }) => {
  const dispatch = useDispatch()

  const handleChangePage = (event, newPage) => {
    event.preventDefault()
    dispatch(updateSkip('class', newPage))
  }
  const handleChangeRowsPerPage = (event) => {
    event.preventDefault()
    const value = parseInt(event.target.value, 10)
    dispatch(updateRowsPerPage('class', value))
  }

  return (
    <>
      <div className='bg-background sticky top-0px flex justify-end items-center h-12 z-10'> 
        <TablePagination
          component="div"
          count={totalList}
          page={skip}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          onPageChange={handleChangePage}
        />
      </div>
      <div className='px-1 py-2'>
        <Grid container spacing={1}>
          { loading && [...Array(rowsPerPage).keys()].map((index) => (
            <Grid item xs={12} lg={12/5} md={12/4} sm={12/3} key={`row-grid-loading-${index}`}>
              <Skeleton variant="rectangular" className='rounded' width='100%' height={200} />
            </Grid>
          ))}
          {!loading && list.map((row, index) =>
            <Grid item xs={12} lg={12/5} md={12/4} sm={12/3} key={`row-list-class-${row._id}-${index}`}>
              <CardClass 
                title={row.code}
                columns={columns}
                {...row} 
              />
            </Grid>
          )}
          {!loading && list.length === 0 && (
            <Grid item xs={12}>
              <Typography className='text-center text-muted-foreground opacity-50'>You don't have any classes yet</Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  )
}

export default ViewGrid